@if (type() === 'link') {
	<a
		(click)="click()"
		[class.disabled]="disabled()"
		[mosClickClassTimer]="250"
		[routerLink]="$any(commands())"
		class="button"
		mosClickClass
	>
		<ng-container [ngTemplateOutlet]="content" />
	</a>
}

@if (type() !== 'link') {
	<button
		(mosLongPress)="_longPress ? click() : null"
		(mosLongPressProgress)="progress = $event"
		(click)="_longPress ? null : click()"
		[disabled]="disabled()"
		[mosClickClassTimer]="250"
		[type]="type()"
		mosClickClass
		[class.loading]="loading()"
		[class.unlocked]="_longPress && progress >= 1"
	>
		<ng-container [ngTemplateOutlet]="content" />
	</button>
}
<div
	class="error"
	[class.show]="errorMessage.length > 0"
	#error
	[class.ellipsis]="error.offsetWidth < error.scrollWidth"
	[mosTooltip]="error.offsetWidth < error.scrollWidth ? errorMessage : ''"
	mosTooltipError
	mosTooltipPosition="bottom"
>
	{{ errorMessage }}
</div>

@if (particleEmitterConfig && !isMobileApp()) {
	<mos-canvas-emitter #stars [config]="particleEmitterConfig" />
}

<ng-template #content>
	@if (_longPress) {
		<div class="progress" [style.width.%]="progress * 100"></div>
	}
	<div class="content">
		<ng-content />
	</div>
</ng-template>
